"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var usePromiseCallback_1 = tslib_1.__importDefault(require("@eduzz/houston-hooks/usePromiseCallback"));
var houston_styles_1 = tslib_1.__importDefault(require("@eduzz/houston-styles"));
var Button_1 = tslib_1.__importDefault(require("../../Button"));
var Portal_1 = tslib_1.__importDefault(require("../../Portal"));
var Typography_1 = tslib_1.__importDefault(require("../../Typography"));
var context_1 = tslib_1.__importDefault(require("../Row/context"));
var TableActionOption = function (_a) {
    var id = _a.id, Tag = _a.as, children = _a.children, disabled = _a.disabled, onClick = _a.onClick, icon = _a.icon, className = _a.className, rest = tslib_1.__rest(_a, ["id", "as", "children", "disabled", "onClick", "icon", "className"]);
    var registerAction = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.registerAction; });
    var data = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.data; });
    var index = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.index; });
    var portal = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.portals.actions; });
    var setLoading = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.setActionLoading; });
    var closeMenu = (0, use_context_selector_1.useContextSelector)(context_1.default, function (context) { return context.closeMenu; });
    React.useEffect(function () {
        var unregister = registerAction();
        return function () { return unregister(); };
    }, [registerAction]);
    var handleClick = (0, usePromiseCallback_1.default)(function (isSubscribed, event) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var promise;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    closeMenu();
                    promise = onClick(data, index, event);
                    if (!(promise instanceof Promise))
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, promise];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [closeMenu, data, index, onClick, setLoading]);
    var content = ((0, jsx_runtime_1.jsx)(Button_1.default, tslib_1.__assign({ id: id, startIcon: icon, variant: 'text', onClick: handleClick, className: className, disabled: disabled }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, tslib_1.__assign({ color: 'inherit' }, { children: children })) })));
    if (Tag) {
        content = ((0, jsx_runtime_1.jsx)(Tag, tslib_1.__assign({ id: id }, rest, { children: content })));
    }
    return (0, jsx_runtime_1.jsx)(Portal_1.default, tslib_1.__assign({ target: portal }, { children: content }));
};
/**
 * @deprecated Use Table from Antd
 * https://ant.design/components/table/
 */
exports.default = (0, houston_styles_1.default)(React.memo(TableActionOption))(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  justify-content: start;\n  text-align: left;\n  border-radius: 0;\n\n  &.hst-button-disabled {\n    background-color: transparent;\n  }\n"], ["\n  justify-content: start;\n  text-align: left;\n  border-radius: 0;\n\n  &.hst-button-disabled {\n    background-color: transparent;\n  }\n"])));
var templateObject_1;
